import { Link } from "react-router-dom";

export const LogoMark = ({ size = 36 }) => (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" aria-hidden="true">
        <rect width="36" height="36" rx="8" fill="#0F172A" />
        <path
            d="M10.5 25.5 L18 10.5 L25.5 25.5"
            stroke="#FFFFFF"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.6 20.2 H22.4" stroke="#3B82F6" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
);

export const Wordmark = () => (
    <span className="flex flex-col justify-center leading-none" aria-label="Apan Code Labs LLP">
        <span className="font-display text-[17px] font-bold tracking-tight text-slate-900">
            APAN
        </span>
        <span className="mt-1 font-mono text-[8.5px] uppercase tracking-[0.34em] text-slate-500">
            Code Labs LLP
        </span>
    </span>
);

export const Logo = () => (
    <Link
        to="/"
        data-testid="nav-logo-link"
        className="flex items-center gap-3 transition-opacity duration-300 hover:opacity-75"
        aria-label="Apan Code Labs — home"
    >
        <LogoMark />
        <Wordmark />
    </Link>
);
